import React from "react";
import HeroImage from "../components/HeroImage";
import HeroVideo1 from "../components/HeroVideo1";

import backgroundimage from "../assets/images/contact.png";
import video2 from "../assets/videos/service2.mp4";

function TermsAndConditions() {
  return (
    <div>
      <HeroImage backgroundImage={backgroundimage} />
      <div className="bg-black text-white p-4 md:p-8 lg:p-16">
        <h1 className="text-4xl font-bold mb-4 text-red-600">
          Algemene Voorwaarden
        </h1>
        <p className="mb-4 font-bold">
          Algemene Voorwaarden Xtreme Car Tuning <br />
          Artikel 1 - Definities
        </p>
        <p>In deze voorwaarden wordt verstaan onder:</p>
        <ol className="list-inside mb-4">
          <li className="mb-2">
            <strong>Xtreme Car Tuning:</strong> De eenmanszaak of onderneming
            die chiptuning en gerelateerde diensten aanbiedt.
          </li>
          <li className="mb-2">
            <strong>Klant:</strong> De natuurlijke of rechtspersoon die
            gebruikmaakt van de diensten van Xtreme Car Tuning.
          </li>
          <li className="mb-2">
            <strong>Diensten:</strong> Alle door Xtreme Car Tuning aangeboden
            werkzaamheden, waaronder chiptuning, diagnose, advies en
            testbankmetingen.
          </li>
          <li className="mb-2">
            <strong>Overeenkomst:</strong> De mondelinge of schriftelijke
            afspraak tussen Xtreme Car Tuning en de klant over de te verrichten
            diensten.
          </li>
        </ol>
        <p className="mb-4 font-bold">Artikel 2 - Toepasselijkheid</p>
        <ol className="list-inside mb-4">
          <li className="mb-2">
            Deze algemene voorwaarden zijn van toepassing op alle offertes,
            werkzaamheden, overeenkomsten en leveringen van Xtreme Car Tuning.
          </li>
          <li className="mb-2">
            Afwijkingen op deze voorwaarden zijn alleen geldig indien
            schriftelijk overeengekomen.
          </li>
        </ol>
        <p className="mb-4 font-bold">Artikel 3 - Uitvoering van de Diensten</p>
        <ol className="list-inside mb-4">
          <li className="mb-2">
            Xtreme Car Tuning voert de werkzaamheden uit naar beste kunnen en
            volgens de geldende standaarden binnen de branche.
          </li>
          <li className="mb-2">
            De klant dient vooraf eventuele technische gebreken of eerdere
            aanpassingen aan het voertuig te melden. Xtreme Car Tuning is niet
            verantwoordelijk voor verborgen gebreken of onjuist verstrekte
            informatie.
          </li>
          <li className="mb-2">
            Xtreme Car Tuning behoudt zich het recht voor om een opdracht te
            weigeren indien er twijfel bestaat over de technische staat van het
            voertuig.
          </li>
          <li className="mb-2">
            Chiptuning wordt uitgevoerd op eigen risico van de klant. Xtreme Car
            Tuning is niet verantwoordelijk voor schade die ontstaat als gevolg
            van bestaande slijtage, achterstallig onderhoud of defecten die niet
            vooraf bekend waren.
          </li>
        </ol>
        <p className="mb-4 font-bold">Artikel 4 - Aansprakelijkheid</p>
        <ol className="list-inside mb-4">
          <li className="mb-2">
            Xtreme Car Tuning is niet aansprakelijk voor schade die voortkomt
            uit mechanische, elektronische of softwarematige defecten die
            aanwezig waren vóór of onafhankelijk van de tuning.
          </li>
          <li className="mb-2">
            Xtreme Car Tuning is niet verantwoordelijk voor schade als gevolg
            van verkeerd of achterstallig onderhoud, eerdere (onbekende)
            reparaties, teruggedraaide kilometerstanden of verborgen gebreken.
          </li>
          <li className="mb-2">
            De klant is verantwoordelijk voor het controleren van de
            voertuigconditie voorafgaand aan de tuning. Eventuele problemen die
            na de tuning ontstaan en niet direct aantoonbaar door Xtreme Car
            Tuning zijn veroorzaakt, vallen niet onder aansprakelijkheid.
          </li>
          <li className="mb-2">
            Eventuele garanties op de software gelden alleen indien de auto in
            originele staat verkeert en correct wordt onderhouden.
          </li>
        </ol>
        <p className="mb-4 font-bold">Artikel 5 - Garantie</p>
        <ol className="list-inside mb-4">
          <li className="mb-2">
            Xtreme Car Tuning biedt garantie op de software-aanpassingen, maar
            niet op mechanische of elektronische onderdelen van het voertuig.
          </li>
          <li className="mb-2">
            Indien blijkt dat de tuning softwarematige fouten bevat, zal Xtreme
            Car Tuning kosteloos een correctie uitvoeren.
          </li>
          <li className="mb-2">
            Schade door externe factoren zoals defecte sensoren, slechte
            brandstofkwaliteit, olielekkages, versleten motoronderdelen of
            eerdere defecten vallen buiten de garantie.
          </li>
        </ol>
        <p className="mb-4 font-bold">Artikel 6 - Betaling en Annulering</p>
        <ol className="list-inside mb-4">
          <li className="mb-2">
            Betaling dient direct na uitvoering van de werkzaamheden te
            geschieden, tenzij anders overeengekomen.
          </li>
          <li className="mb-2">
            Bij annulering binnen 24 uur voor de afspraak kan Xtreme Car Tuning
            kosten in rekening brengen.
          </li>
          <li className="mb-2">
            Indien een voertuig door technische gebreken niet getuned kan
            worden, kan een onderzoekstarief in rekening worden gebracht.
          </li>
        </ol>
        <p className="mb-4 font-bold">
          Artikel 7 - Geschillen en Toepasselijk Recht
        </p>
        <ol className="list-inside mb-4">
          <li className="mb-2">
            Op alle overeenkomsten en diensten van Xtreme Car Tuning is het
            Nederlands recht van toepassing.
          </li>
          <li className="mb-2">
            Geschillen worden in eerste instantie in onderling overleg opgelost.
            Indien dit niet lukt, wordt het geschil voorgelegd aan de bevoegde
            rechtbank.
          </li>
        </ol>
        <p className="mb-4 font-bold">Slotbepaling</p>
        <p className="mb-4">
          Door gebruik te maken van de diensten van Xtreme Car Tuning gaat de
          klant akkoord met deze algemene voorwaarden.
        </p>
      </div>
      <HeroVideo1
        videoSource={video2}
        heading="Enthousiast geworden en wilt u uw auto ook terugzien op onze website?Klik hier om een afspraak te maken."
        buttontext="Zoek uw optimalisatie"
        buttonlink="/contact-us"
      />
    </div>
  );
}

export default TermsAndConditions;
